// extracted by mini-css-extract-plugin
export default {"powered-by-logo":"PoweredByBranding-styles-module__powered-by-logo__nmiw3","poweredByLogo":"PoweredByBranding-styles-module__powered-by-logo__nmiw3"};